export enum WALLET_TRANSACTION {
  ORDER_NUMBER = 'orderNumber',
  TRANSACTION_TYPE = 'transactionType',
  AMOUNT = 'amount',
  TRANSACTION_REASON = 'transactionReason',
  CREATED_AT = 'createdAt',
}

export enum TRANSACTION_TYPES {
  IN = 'in',
  OUT = 'out',
}
